import React from "react";
import styles from "./ErrorBoundary.scss";

class ErrorBoundary extends React.Component {
    state = {
        hasError: false,
    };

    componentDidCatch(error, errorInfo) {
        if (this.props.onError) {
            const isHandled = this.props.onError(error, errorInfo);
            if (!isHandled) {
                this.setState({hasError: true});
            }
        } else {
            this.setState({hasError: true});
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.root}>
                    <div className={styles.content}>
                        <div className="margin-bottom-md"><i className="fa fa-5x fa-exclamation-triangle" /></div>
                        <div className="text-lg">
                            Something went wrong! If the problem persists, please contact us.
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}


export default ErrorBoundary;